import React from "react";
import * as moment from "moment";

const DateTimeFormatter = ({ date, time }) => {

    const datePart = moment(date).format("DD.MM.YYYY");
    const timePart = time ? moment(time).format("HH:mm") : moment(date).format("HH:mm");

    return (
        <>
            {datePart} {timePart}
        </>
    );
};

export default DateTimeFormatter;